















import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { NotificationChannelCodes } from "@/data/enums/notifications";
import { TemplateTypes } from "@/data/enums/templates";
import { AdminRoutes } from "@/data/enums/router";

// Types
import { ITemplate } from "@/models/templates";

@Component({
  components: {
    "template-provider": () =>
      import("@/components/app/global/templates/templateProvider.vue"),
    "notification-template-add-edit-form": () =>
      import(
        "@/components/app/global/templates/notifications/templateAddEditForm.vue"
      )
  }
})
export default class AdminEditEmailTemplateView extends Vue {
  // Props

  @Prop({ default: null })
  public templateId!: ITemplate["id"];

  // Data

  public emailNotificationChannel = NotificationChannelCodes.EMAIL;
  public templateType = TemplateTypes.NOTIFICATION;

  // Methods

  public onDuplicate({ newTemplate }) {
    this.$router.replace({
      name: AdminRoutes.EMAIL_TEMPLATE_EDIT,
      params: { templateId: newTemplate.id }
    });
  }

  public onChange({ templateId }) {
    this.$router.replace({
      name: this.$route.name as string,
      params: { templateId }
    });
  }

  public onRestored({ templateId }: { templateId: ITemplate["id"] }) {
    this.$router.replace({
      name: AdminRoutes.EMAIL_TEMPLATE_EDIT,
      params: { templateId }
    });
  }
}
